import { FC, createElement } from 'react';
import { List } from './list';

export const ListContainer: FC = () => {
  return createElement(List);
};
